import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import IconWarning from '@/shared/icons/NewDesign/IconWarning'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'

const ElectricCarDistance = () => {
  const { t, energyLandscape, updateAddressEnergyLandscape, errors } = useAddress()
  const isPulse = usePulseScope()

  const { electricCar, electricCarDistance } = energyLandscape
  const [smallDistance, mediumDistance, largeDistance] = [
    t('subscriptionTools:estimator.equipment.electric_car_distance_small'),
    t('subscriptionTools:estimator.equipment.electric_car_distance_medium'),
    t('subscriptionTools:estimator.equipment.electric_car_distance_large'),
  ]

  if (!electricCar) {
    return null
  }

  return (
    <>
      <SDFormControl plainLabel error={getError('electricCarDistance', errors)}>
        <SDInput
          label={t('subscriptionTools:estimator.equipment.electric_car_distance')}
          onBlur={value => {
            const filteredOnlyNumberValue = value?.replace(/[^0-9]/g, '')
            updateAddressEnergyLandscape({
              electricCarDistance: filteredOnlyNumberValue || null,
            })
          }}
          currentValue={electricCarDistance}
          endEnhancer={t('common:km_by_year')}
        />
      </SDFormControl>
      {isPulse ? (
        <SDNotification type='warning' primaryText={[smallDistance, mediumDistance, largeDistance].join('<br />')} />
      ) : (
        <div
          style={{
            display: 'flex',
            marginBottom: '1rem',
            padding: '.5rem',
            gap: '.5rem',
            borderRadius: '.5rem',
            border: '1px dashed #D2A604',
            backgroundColor: '#FFEBC3',
          }}
        >
          <IconWarning size={24} color='#D2A604' />
          {smallDistance} <br />
          {mediumDistance} <br />
          {largeDistance}
        </div>
      )}
    </>
  )
}

export default ElectricCarDistance
